import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import isSameDay from 'react-dates/lib/utils/isSameDay'

import { PRODUCT_LAUNCH_DATE } from 'constants/product_costs'
import { humanizeDate } from 'helpers/date'
import { CalendarInputOptionGroup } from 'ui_elements/CalendarInputOptionGroup/CalendarInputOptionGroup'

export const EditableDateCell = props => {
  const { value, onChange, rows } = props
  const [date, setDate] = useState(moment(value))
  const [blockedDates, setBlockedDates] = useState([])
  const { t } = useTranslation()

  useEffect(() => {
    setDate(moment(value))
  }, [value])

  useEffect(() => {
    const effectiveDates = rows.map(row => {
      return moment(row.original.date_effective)
    })

    setBlockedDates(effectiveDates)
  }, [rows])

  const getDateDisplayValue = val => {
    if (isSameDay(moment(val), moment(PRODUCT_LAUNCH_DATE))) {
      return t('product_cost:LogisticsRow.dateOption', 'Since Product Launch')
    }

    return humanizeDate(val)
  }

  return (
    <CalendarInputOptionGroup
      displayValue={getDateDisplayValue(value)}
      value={date}
      options={[
        {
          label: t(
            'product_cost:LogisticsRow.dateOption',
            'Since Product Launch'
          ),
          value: moment(PRODUCT_LAUNCH_DATE).format('YYYY-MM-DD')
        }
      ]}
      small
      id="productCost-datePicker"
      key="productCost-datePicker"
      startDate={date}
      mode="single"
      blockedTooltip={t(
        'product_cost.LogisticsRow.blockedTooltip',
        'Previous Effective Date, cannot select this date.'
      )}
      isDayBlocked={day => blockedDates.some(_date => isSameDay(day, _date))}
      onFocusChange={() => {}}
      onDatesChange={newValue => {
        onChange(newValue.format('YYYY-MM-DD'))
      }}
      blockPastDates
      closeOnDatesChange
      width="370px"
    />
  )
}

EditableDateCell.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  rows: PropTypes.arrayOf(PropTypes.object).isRequired
}
